"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles = __importStar(require("./ComboBoxFilter.css"));
const Select_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Select"));
const React = __importStar(require("react"));
const constants = __importStar(require("../../search/constants"));
const constants_1 = require("../../search/constants");
const ComboBoxFilter = (props) => {
    const { id, value, handleChange, disabled, showAny, anyOptionLabel } = props;
    const options = props.options.map(o => ({
        value: o[constants.GuiOptionKey],
        label: o[constants.GuiOptionLabel] || o[constants.GuiOptionKey],
        disabled: !!o[constants.GuiDisabled],
    }));
    if (showAny) {
        options.unshift({
            disabled,
            label: anyOptionLabel,
            value: constants_1.SEARCH_ANY_OPTION_KEY,
        });
    }
    return (React.createElement("div", { className: styles.comboBoxFilter, "data-test-id": `ComboBoxFilter` },
        React.createElement(Select_1.default, { id: id, options: options, value: value, size: 'lg', testId: 'combo-box-filter', onChange: handleChange, "aria-labelledby": id + '-label', disabled: disabled })));
};
exports.default = ComboBoxFilter;
